import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './FAQ.scss';
import FAQItem from './FAQItem';
import { IQuestionAnswer } from '../../types/content';
import SeeAllFaq from '../UI/Buttons/SeeAllFaq';
import { adobeTrack } from '../../utils';

interface IFAQProps {
  context?: IContent;
}

const FAQ = ({ context }: IFAQProps) => {
  return (
    <section className="ubisoft-plus_faq">
      <div className="ubisoft-plus_container">
        <h1 className="dark">{context.faq.title}</h1>
        <div className="accordion_section">
          {context.faq.QuestionAnswer.map(
            (QA: IQuestionAnswer, index: number) => {
              if (QA.question !== '' && QA.answer !== '') {
                return (
                  <FAQItem key={'QA_' + index} item={QA} trackingText={context.tracking.faq_item_click} />
                );
              }
            })
          }
        </div>
        <div className="see_all_faq_btn ubisoft-plus_cta_wrapper">
          <SeeAllFaq content={context.cta[context.faq.cta.type]} redirect={context.faq.cta.redirection}
                     handleClick={() =>
                       adobeTrack('clickevent', context.tracking.faq_button_click)
                     } />
        </div>
      </div>
    </section>
  );
};

export default withContent(FAQ);
